const {setClass} = require("nevermorejs/lib/dom");

class ItemClass {

	constructor(container) {
		container.on("itemMount", (item) => this.setItemClass(container, item));
		container.on("itemChange", (item) => this.setItemClass(container, item));
		container.on("itemAdd", (item) => this.setItemClass(container, item));
	}

	setItemClass(container, item) {
		setClass(item.dom, "nvm-item-small", item.to.diff(item.from, "hours") < 4);
	}

}

module.exports = ItemClass;



// WEBPACK FOOTER //
// ./resources/js/components/backend/calendar/plugins/ItemClass.js